import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject, _templateObject2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import '@nike/nike-one-video-player/dist/nike-one-video-player.min.css';
import NikeOneVideoPlayer from '@nike/nike-one-video-player';
import { GridItem } from '@nike/nike-design-system-components';
import styled from '@emotion/styled';
import { nike } from '@nike/nike-design-tokens';
import Imagetext from '../Imagetext/Imagetext';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// PMEEXP-6057
var handleAnalyticsEvent = function handleAnalyticsEvent(mediaHost, video) {
  if (window.dtmData && window.aaData) {
    window.aaData.push(_objectSpread(_objectSpread({}, window.dtmData), {}, {
      app: 'homepage',
      event: 'interaction',
      interactionName: "homepage:play_video:".concat(mediaHost).concat(video)
    }));
  }
};
var VideoComponent = function VideoComponent(props) {
  var mediaHost = props.mediaHost,
    _props$root = props.root,
    _props$root$theme = _props$root.theme,
    theme = _props$root$theme === void 0 ? 'light' : _props$root$theme,
    _props$root$video = _props$root.video,
    _props$root$video2 = _props$root$video === void 0 ? {} : _props$root$video,
    video = _props$root$video2.fileReference,
    _props$root$poster = _props$root.poster,
    _props$root$poster2 = _props$root$poster === void 0 ? {} : _props$root$poster,
    poster = _props$root$poster2.fileReference;
  var VideoPlayerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .vjs-poster {\n      background-position: 0;\n      background-size: cover;\n    };\n  "])));
  var VideoDescriptionContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 100%;\n    background-color: ", ";\n    .nds-skeleton {\n      background: none;\n      border: none;\n    };\n    .nds-content-card {\n      height: 100%;\n    }\n  "])), theme === 'light' ? nike.podiumCdsColorBlack : nike.podiumCdsColorWhite);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      xs: 8,
      style: {
        paddingLeft: 0
      },
      children: /*#__PURE__*/_jsx(VideoPlayerContainer, {
        children: /*#__PURE__*/_jsx(NikeOneVideoPlayer, {
          preset: "controls"
          // @ts-expect-error
          ,
          height: "auto",
          captionsDefaultOn: true,
          language: "en-US",
          ariaLabel: "Test video",
          poster: "".concat(mediaHost).concat(poster),
          sources: [{
            src: "".concat(mediaHost).concat(video),
            type: 'video/mp4'
          }]
          // onAnalyticsEvent={() => sendInteractionEvent(`homepage:${mediaHost}:${video}:${poster}`)}
          ,
          onAnalyticsEvent: function onAnalyticsEvent() {
            return handleAnalyticsEvent(mediaHost, video);
          }
        })
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      xs: 4,
      style: {
        paddingRight: 0,
        paddingLeft: undefined
      },
      children: /*#__PURE__*/_jsx(VideoDescriptionContainer, {
        "data-testid": "video-desc-container",
        children: /*#__PURE__*/_jsx(Imagetext, _objectSpread({}, props))
      })
    })]
  });
};
export default VideoComponent;